import React from 'react';
import { useParams } from 'react-router-dom';
import BrandAnaylzerComponent from '../includes/brandanalyzer';


export default function BrandAnalyzer() {
    const { id } = useParams()
    return <BrandAnaylzerComponent id={id || -1} />
}